export default __webpack_public_path__ + "static/Atkinson-Hyperlegible-Regular-102-0f70189614a5d1405a86b2f339e97711.ttf";